<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-autocomplete
          label="Tipo de portafolios"
          v-model="polizaData.tipoPortafolios"
          :items="tipoPortafoliosList"
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-autocomplete
          label="Fumador"
          v-model="polizaData.fumador"
          :items="fumadorList"
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-text-field
          label="Plazo comprometido"
          v-model="polizaData.plazoComprometido"
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
          readonly
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-autocomplete
          label="Deducibilidad"
          v-model="polizaData.deducibilidad"
          :items="deducibilidadList"
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-autocomplete
          label="Revaluable con la inflación"
          v-model="polizaData.revaluableInflacion"
          :items="revaluableInflacionList"
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-autocomplete>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-text-field
          label="Valor del Plan"
          v-model="polizaData.valorPlan"
          prefix="$"
          v-number-only
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-text-field>
      </v-col>
      <v-col cols="12" md="6" lg="3" xl="3">
        <v-text-field
          label="Monto de la inversión/Aportación"
          v-model="polizaData.montoInversion"
          prefix="$"
          v-number-only
          outlined
          color="#00a7e4"
          :rules="inputsRequeridos"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12" xl="12" style="text-align: end;">
        <v-btn
          rounded
          dark
          outlined
          color="#00a7e4"
          @click="$emit('beforeStep')"
          style="margin-right: 11px;"
        >
          <span>
            Anterior
          </span>
        </v-btn>
        <v-btn
          rounded
          dark
          class="common-botton"
          @click="$emit('goToSave', polizaData)"
        >
          <span>
            Guardar
          </span>
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  directives: {
    "number-only": {
      bind(el) {
        function checkValue(event) {
          event.target.value = event.target.value.replace(/[^0-9]/g, "");
          if (event.charCode >= 48 && event.charCode <= 57) {
            return true;
          }
          event.preventDefault();
        }
        el.addEventListener("keypress", checkValue);
      },
    },
    "letter-only": {
      bind(el) {
        function checkValue(event) {
          if (event.charCode >= 48 && event.charCode <= 57) {
            event.preventDefault();
          }
          return true;
        }
        el.addEventListener("keypress", checkValue);
      },
    },
  },
  props:{
    anios:String
  },
  data() {
    return {
      polizaData: {
        tipoPortafolios: null,
        fumador: null,
        plazoComprometido: this.anios,
        deducibilidad: null,
        revaluableInflacion: null,
        valorPlan: null,
        montoInversion: null,
      },

      //listas
      tipoPortafoliosList: [
        "Moderado",
        "Medio",
        "Agresivo",
        "Elite Inversión",
        "Patrimonial Inversión",
        "Plus",
        "Educacional",
      ],
      fumadorList: ["Si", "No"],
      deducibilidadList: ["Si", "No"],
      revaluableInflacionList: ["Si", "No"],

      //Validadores
      inputsRequeridos: [(value) => !!value || "Campo Requerido"],
    };
  },
  watch: {
    anios(){
      this.polizaData.plazoComprometido = this.anios
    }
  },
};
</script>
